import {
    getMethod,
    postMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setCategories,
    addCategory,
    removeCategory
} from "./blogCategorySlice";

/* GET */
export const fetchCategories = () => async (dispatch) => {
    const res = await getMethod("/blog-category");
    if (res?.success) dispatch(setCategories(res.categories));
};

/* CREATE */
export const createCategory = (data) => async (dispatch) => {
    const res = await postMethod("/blog-category", data);
    if (res?.success) dispatch(addCategory(res.category));
    return res;
};

/* DELETE */
export const deleteCategory = (id) => async (dispatch) => {
    const res = await deleteMethod(`/blog-category/${id}`);
    if (res?.success) dispatch(removeCategory(id));
    return res;
};